var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c(
      "form",
      {
        staticClass: "sign-up is-centered",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          }
        }
      },
      [
        _c("img", {
          attrs: { src: _vm.$store.getters["ui/authLogo"], alt: "logo" }
        }),
        _c("h1", { staticClass: "title is-4 has-text-primary" }, [
          _vm._v("\n      Nueva Contraseña\n    ")
        ]),
        _c("div", { staticClass: "columns is-multiline" }, [
          _c("div", { staticClass: "column is-12" }, [
            _c("p", { staticClass: "notification" }, [
              _vm._v("\n          Bienvenido " + _vm._s(_vm.name) + ". "),
              _c("br"),
              _vm._v("\n          Ingresa tu nueva contraseña.\n        ")
            ])
          ]),
          _c(
            "div",
            { staticClass: "column is-12-mobile is-12-fullhd is-6" },
            [
              _c("AppInputPassword", {
                attrs: {
                  value: _vm.password,
                  disabled: _vm.loading,
                  required: ""
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column is-12-mobile is-12-fullhd is-6" },
            [
              _c("AppInputPassword", {
                attrs: {
                  id: "passwordConfirmation",
                  name: "passwordConfirmation",
                  label: "Repetir Contraseña",
                  "error-message": "Las contraseñas no coinciden",
                  value: _vm.passwordConfirmation,
                  pattern: _vm.password,
                  disabled: _vm.loading,
                  required: ""
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          )
        ]),
        _c("ButtonSubmit", {
          attrs: {
            loading: _vm.loading,
            disabled: _vm.loading,
            text: "guardar contraseña"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }